module.exports = __webpack_public_path__ + "img/choose-your-forex-logo.b790d9da.png";